import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DownloadDoneIcon from '@mui/icons-material/DownloadDone'

import axios from 'axios'
import PropTypes from 'prop-types'
import { toast } from 'react-toastify'

import '../styles/components/addCocktail.scss'
import { useNavigate } from 'react-router-dom'

const AddCocktail = ({ modal, setModal, cocktail, setCocktail }) => {
  const imagesMandatory = false

  const [image, setImage] = useState(null)
  const [cocktailName, setCocktailName] = useState('')
  const [ingredients, setIngredients] = useState('')
  const [description, setDescription] = useState('')

  const navigate = useNavigate()

  useEffect(() => {
    if (cocktail) {
      setCocktailName(cocktail.name)
      setIngredients(cocktail.ingredients.join('\r\n'))
      setDescription(cocktail.description)
    }
  }, [])

  const handleCocktailNameChange = (event) => {
    setCocktailName(event.target.value)
  }

  const handleIngredientsChange = (event) => {
    setIngredients(event.target.value)
  }

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value)
  }

  const handleClose = () => {
    setModal(false)
  }

  const handleImageChange = (event) => {
    const acceptedExtensions = ['jpg', 'png', 'jpeg']
    let accepted = false
    const imageFile = event.target.files[0]

    for (const extension of acceptedExtensions) {
      if (imageFile.name.toLowerCase().includes(extension)) {
        accepted = true
        break
      }
    }

    if (!accepted) {
      alert('Veuillez charger une photo')
      return
    }

    setImage(imageFile)
  }

  const handleSubmit = (event) => {
    event.preventDefault()

    if (cocktail) {
      const cocktailData = new FormData()
      cocktailData.append('name', cocktailName)
      cocktailData.append('ingredients', ingredients)
      cocktailData.append('description', description)
      if (image) {
        cocktailData.append('image', image)
      }

      axios({
        method: 'put',
        url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/cocktails/${cocktail._id}`,
        headers: { Authorization: sessionStorage.getItem('token') },
        data: cocktailData,
      })
        .then((res) => {
          setCocktail(res.data)
          toast.success('Le cocktail a été modifié avec succès')
        })
        .catch((error) => {
          if (error.response.status === 401) {
            toast.error('veuillez vous connecter')
            sessionStorage.clear()
          } else {
            console.error(error)
            toast.error(error.message)
          }
        })
    } else {
      if (!image && imagesMandatory) {
        alert('Veuillez charger une photo')
        return
      }

      const cocktailData = new FormData()
      cocktailData.append('name', cocktailName)
      cocktailData.append('ingredients', ingredients)
      cocktailData.append('description', description)
      cocktailData.append('image', image)

      axios({
        method: 'post',
        url: `https://${process.env.REACT_APP_HOST_IP_ADDRESS}/api/cocktails`,
        headers: { Authorization: sessionStorage.getItem('token') },
        data: cocktailData,
      })
        .then((res) => {
          toast.success('Le cocktail a été créé avec succès')
          navigate(`/cocktail/${res.data}`)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            toast.error('veuillez vous connecter')
            sessionStorage.clear()
          } else {
            console.error(error)
            toast.error(error.message)
          }
        })
    }

    handleClose()
  }

  return (
    <div>
      <Modal
        open={modal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="box-modal-add-cocktail">
          <h3>
            {!cocktail ? 'Ajouter un nouveau cocktail' : 'Modifier le cocktail'}
          </h3>
          <form onSubmit={handleSubmit}>
            <Button
              className="add-photo"
              variant="contained"
              component="label"
              startIcon={<AddAPhotoIcon />}
              endIcon={image ? <DownloadDoneIcon /> : null}
              onChange={handleImageChange}
            >
              Charger une photo
              <input hidden type="file" />
            </Button>
            <TextField
              className="cocktail-name"
              label="Nom du cocktail"
              variant="standard"
              onChange={handleCocktailNameChange}
              value={cocktailName}
              required
            />
            <TextField
              fullWidth
              className="text"
              id="outlined-textarea"
              label="Ingédients"
              multiline
              rows={2}
              onChange={handleIngredientsChange}
              value={ingredients}
              required
            />
            <TextField
              fullWidth
              className="text"
              id="outlined-textarea"
              label="Descriptif"
              multiline
              onChange={handleDescriptionChange}
              value={description}
            />
            <Button
              type="submit"
              variant="contained"
              endIcon={<AddCircleOutlineIcon />}
            >
              {!cocktail ? 'Ajouter' : 'Modifier'}
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  )
}

AddCocktail.propTypes = {
  modal: PropTypes.bool.isRequired,
  setModal: PropTypes.func.isRequired,
  cocktail: PropTypes.object,
  setCocktail: PropTypes.func,
}

export default AddCocktail
